import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCompassSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCompassSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM9.68132 9.68132L15.478 8.52197L14.3187 14.3187L8.52197 15.478L9.68132 9.68132Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCompassSquare;
